import heroSwimmer from "../assets/hero-swimmer.webp"
import { Link } from "../lib/router"
import { useLanguage } from "../lib/LanguageContext"

export default function Hero() {
  const { t } = useLanguage()
  return (
    <section
      id="hero"
      className="relative flex min-h-[100svh] items-center overflow-hidden pt-24 [@media(min-height:700px)]:min-h-[880px]"
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(120% 90% at 15% -10%, rgba(232,204,142,.16), transparent 55%), linear-gradient(200deg, #133645 0%, #0c2530 42%, #0A1D26 78%)",
        }}
        aria-hidden="true"
      >
        <div
          className="animate-hero-pan absolute -inset-[6%] bg-cover"
          style={{
            backgroundImage: `url(${heroSwimmer})`,
            backgroundPosition: "center 20%",
            opacity: 0.95,
            filter: "saturate(1.05) brightness(1.05)",
          }}
        />
      </div>
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(8,20,25,.1) 0%, rgba(8,20,25,.1) 45%, rgba(8,20,25,.5) 75%, #0F2732 100%)",
        }}
        aria-hidden="true"
      />

      <div className="container relative z-10 mx-auto max-w-content px-6 pb-24 sm:px-16">
        <div className="max-w-[640px]">
          <div className="mb-6 flex items-center gap-3 drop-shadow-sm">
            <span className="h-px w-10 shrink-0 bg-gold-300" />
            <span className="text-[.8125rem] font-bold uppercase tracking-[.22em] text-gold-300 drop-shadow-md">
              {t("hero_eyebrow")}
            </span>
          </div>
          <h1 className="mb-8 text-balance font-display text-[clamp(2.75rem,5vw,4.75rem)] font-bold leading-[1.12] tracking-[-0.01em] text-paper-0 drop-shadow-lg">
            {t("brand_tagline")}
          </h1>
          <p className="mb-12 max-w-[520px] text-lg font-medium leading-[1.7] text-paper-0 drop-shadow-md">
            {t("hero_body")}
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-6">
            <Link
              to="/signup"
              className="flex w-full sm:w-auto items-center justify-center bg-gold-500 px-6 py-4 text-sm font-semibold tracking-[.02em] text-ink-900 hover:bg-gold-400"
            >
              {t("cta_primary")}
            </Link>
            <Link
              to="/login"
              className="flex w-full sm:w-auto items-center justify-center border border-white/40 bg-white/10 px-6 py-4 text-sm font-semibold tracking-[.02em] text-paper-0 backdrop-blur-sm transition-all hover:border-white/80 hover:bg-white/20"
            >
              {t("cta_secondary")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
